import { render } from "./MyBanner.vue?vue&type=template&id=5a97e8bf"
import script from "./MyBanner.vue?vue&type=script&lang=js"
export * from "./MyBanner.vue?vue&type=script&lang=js"

import "./MyBanner.vue?vue&type=style&index=0&id=5a97e8bf&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__